import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { MutationError } from '../components/MutationError';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

type Goal = 'ON_SITE' | 'REMOTE';

// AppointmentGoalSection: Terminziel eines Maklers (Dominik 13.10.2026). Für Vor-Ort-Makler ist der Vor-Ort-Termin die Zielstufe,
// ein Telefon- oder Videotermin nur ein „80-%-Termin“ – sichtbar, damit wir nicht in das Telefonmodell abdriften. Für andere
// Makler (z. B. Remote) ist der Telefontermin die höchste Stufe. Ändern darf die Leitung (project.manage).
export function AppointmentGoalSection({ userId, goal, explicit, remote30 }: { userId: string; goal: Goal; explicit: boolean; remote30: number }) {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const qc = useQueryClient();
  const [value, setValue] = useState<'' | Goal | null>(null);
  const save = useMutation({
    mutationFn: (g: '' | Goal) => papi.setAppointmentGoal(userId, g),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: projectKeys.team(project.id) });
      setValue(null);
    },
  });
  const onSite = goal === 'ON_SITE';
  return (
    <section className="card goal-card" aria-labelledby="goal-title">
      <div className="section-head">
        <h2 id="goal-title">Terminziel</h2>
        {can('project.manage') && value === null && (
          <button type="button" className="btn btn-small" onClick={() => setValue(explicit ? goal : '')}>
            Ändern
          </button>
        )}
      </div>
      <p>
        <strong>{onSite ? 'Termin vor Ort' : 'Telefon- bzw. Videotermin'}</strong>
        {!explicit && <span className="muted"> · automatisch nach Vertriebsart des Projekts</span>}
      </p>
      <p className="muted small">
        {onSite
          ? 'Telefon- und Videotermine zählen bei diesem Makler nur als zweitbeste Stufe (80 %) – damit wir nicht in das Telefonmodell abdriften.'
          : 'Für diesen Makler ist der Telefon- oder Videotermin die Zielstufe.'}
        {onSite && remote30 > 0 && ` In den letzten 30 Tagen: ${remote30} Telefon- bzw. Videotermin${remote30 > 1 ? 'e' : ''}.`}
      </p>
      {value !== null && (
        <form
          className="inline-form"
          onSubmit={(e) => {
            e.preventDefault();
            save.mutate(value);
          }}
        >
          <label className="field">
            <span>Terminziel</span>
            <select value={value} onChange={(e) => setValue(e.target.value as '' | Goal)}>
              <option value="">Automatisch (nach Vertriebsart)</option>
              <option value="ON_SITE">Termin vor Ort</option>
              <option value="REMOTE">Telefon- bzw. Videotermin</option>
            </select>
          </label>
          <button type="submit" className="btn btn-primary" disabled={save.isPending}>
            Speichern
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setValue(null)}>
            Abbrechen
          </button>
        </form>
      )}
      {save.isError && <MutationError error={save.error} />}
    </section>
  );
}
